<template>
  <v-dialog v-model="active"
            :width="dialogWidth">
    <!-- inicio de evento de baja -->
    <v-stepper v-model="step">
      <v-progress-linear absolute
                         top
                         active
                         :value="(step) * 100 / 3"
                         height="8"
                         buffer-value="100">
      </v-progress-linear>

      <v-stepper-items class="std-text-md mt-8">
        <!-- inicio dialog 1 -->
        <v-stepper-content step="1">
          <v-row no-gutters class="mb-6">
            <v-col cols="12"
                   class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
              <div class="font-weight-bold col-12 pa-0 mb-4">Baja de ganado</div>
              <div class="col-12 pa-0 mb-2">La vaca <b>{{id}}</b> se dará de baja.</div>
              <div class="col-12 pa-0">¿Estás seguro de hacer esto?</div>
            </v-col>
          </v-row>
          <v-row no-gutters
                 justify="space-between">
            <v-col cols="3" @click="close()">
              <BackButton></BackButton>
            </v-col>
            <v-col cols="5"
                   @click="step++">
              <WarnButton text="Continuar baja"></WarnButton>
            </v-col>
          </v-row>
        </v-stepper-content>
        <!-- fin de dialog 1 -->

        <!-- inicio de dialog 2 -->
        <v-stepper-content step="2">
          <v-row no-gutters class="mb-6">
            <v-col cols="12"
                   class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
              <div class="font-weight-bold col-12 pa-0 mb-4">Baja de ganado</div>
              <div class="col-12 pa-0 mb-2">La vaca <b>{{ id }}</b> se dará de baja.</div>
              <div class="col-12 pa-0">Selecciona la razón de baja de este animal</div>
              <div class="col-8">
                <v-autocomplete
                    class="alerts-autocomplete-birth"
                    dense
                    hide-details
                    clearable
                    v-model="alert.reason"
                    :placeholder="delReasons[0]"
                    :items="delReasons"
                    outlined
                ></v-autocomplete>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters
                 justify="space-between">
            <v-col cols="3" @click="backTwo()">
              <BackButton></BackButton>
            </v-col>
            <v-col cols="5"
                   @click="nextTwo()">
              <WarnButton text="Continuar baja"></WarnButton>
            </v-col>
          </v-row>
        </v-stepper-content>
        <!-- fin de dialog 2 -->

        <!-- inicio de dialog 3 -->
        <v-stepper-content step="3">
          <!-- inicio baja definitiva -->
          <v-row no-gutters
                 class="mb-6"
                 v-if="alert.reason === 'Error al registrar'">
            <v-col cols="12"
                   class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
              <div class="font-weight-bold col-12 pa-0 mb-4">Baja de ganado</div>
              <div class="col-12 pa-0 mb-2 std-text-red-1">La vaca <b>{{id}}</b> se eliminará por completo del sistema y quizá no puedas recuperarla.</div>
            </v-col>
          </v-row>
          <v-row no-gutters
                 v-if="alert.reason === 'Error al registrar'"
                 justify="space-between">
            <v-col cols="3"
                   @click="backThree()">
              <BackButton></BackButton>
            </v-col>
            <v-col cols="5"
                   @click="storeDelete(false)">
              <WarnButton text="Continuar baja">
              </WarnButton>
            </v-col>
          </v-row>
          <!-- fin baja definitiva -->

          <!--  inicio baja temporal -->
          <v-row no-gutters
                 justify="space-between"
                 align="center"
                 v-if="alert.reason !== 'Error al registrar'">
            <v-col cols="5">
              <v-img src="../assets/alert/cow-delete-image.svg"
                     height="300px"
                     contain>
              </v-img>
            </v-col>
            <v-col cols="6"
                   style="position: relative ; height: 300px">
              <v-row no-gutters>
                <v-col cols="12"
                       class="std-text-blue-2 d-flex justify-center flex-wrap text-center">
                  <div class="font-weight-bold col-12 pa-0 mb-6">Baja de ganado</div>
                  <div class="col-12 pa-0 mb-6">{{ description }}</div>
                  <div class="col-12 pa-0 std-text-lg mb-4">La vaca <b>{{id}}</b> se dará de baja por <b>{{ reason }}</b></div>
                  <div class="d-flex justify-lg-space-between col-12 pa-0" style="position: absolute; bottom: 0">
                    <v-col cols="5" class="pa-0" @click="backThree()">
                      <BackButton></BackButton>
                    </v-col>
                    <v-col cols="5" class="pa-0" @click="storeDelete(true)">
                      <WarnButton text="Registrar baja">
                      </WarnButton>
                    </v-col>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-stepper-content>
        <!-- fin de dialog 3 -->
      </v-stepper-items>
    </v-stepper>
    <!-- fin de evento de baja -->
  </v-dialog>
</template>

<script>
  import BackButton from "@/components/BackButton";
  import WarnButton from "@/components/WarnButton";
  import {EventBus} from "@/views/bus";
export default {
  name: "DeleteDialog",
  components: {WarnButton, BackButton},
  data: () => {
    return {
      active: false,
      step: 1,
      key: null,
      animalType: 'cow',
      id: null,
      delReasons: ['Error al registrar', 'Venta a rastro', 'Venta a otro rancho', 'Muerte (Registro de deshecho)'],
      xlWidth: ['40%', '40%', '65%'],
      alert: {
        reason: null
      },
    }
  },
  watch: {
    active(val) {
      if (!val) {
        this.step = 1;
        this.reason.alert = null;
      }
    }
  },
  computed: {
    reason() {
      return !this.alert.reason ? '' : this.alert.reason.toLowerCase();
    },
    description() {
      switch(this.alert.reason) {
        case 'Venta a rastro':
          return 'Vamos a extrañar a este animal, pero en fin... ¿Se va a hacer o no se va a hacer? ¡La carnita asada!';
        case 'Venta a otro rancho':
          return '¡Esperemos que su nuevo dueño la cuide tan bien como tú!'
        case 'Muerte (Registro de deshecho)':
          return '¡Lamentamos tu pérdida! Esperemos que tus otras vacas no se pongan tristes por su partida.'
        default:
          return '';
      }
    },
    dialogWidth() {
      let errRsn = this.alert.reason === 'Error al registrar';
      return errRsn ? '40%' : this.xlWidth[this.step - 1] ;
    }
  },
  methods: {
    close() {
      this.active = false;
    },
    backTwo() {
      this.alert.reason = null;
      this.step = 1;
    },
    nextTwo() {
      // shows a briefly notification
      if (!this.alert.reason) {
        let info = {
          text: '¡Selecciona una razón de baja!',
          type: 'del'
        }
        EventBus.$emit('errSnack', info);
      } else {
        this.step++;
      }
    },
    backThree() {
      this.step = 2;
      this.alert.reason = null;
    },
    storeDelete(soft) {
      let payload = {
        animalType: this.animalType,
        key: this.key,
        soft: soft,
      }
      this.$store.dispatch('deleteAnimal', payload);
      this.active = false;
      this.step = 1;
    }
  },
  created() {
    EventBus.$on('openDeleteDlg', (info) => {
      this.key = info.key;
      this.id = info.id;
      this.animalType = info.animalType;
      this.active = true;
    });
  }
}
</script>

<style scoped>

</style>